import "./Team.css";
import { BoxProvider } from "../../Context/BoxContext";
import BoxWithContent from "../../Components/BoxWithContent";

export default function Team() {
  const heading = "Tarsem Rattu";
  const description =
    "With a passion for innovative design and a keen eye for detail, We brings creative visions to life. As the Lead Architect & Designer at BEAMS, they excel in crafting architectural masterpieces that blend functionality, aesthetics, and sustainability. Their expertise spans interior and exterior design, landscaping, and Vastu insights, ensuring each project reflects the unique aspirations of our clients.";
  // const image = "/assets/images/team1.jpg";
  const gradientColor = "#FDEFDB";
  const buttonVariant = "outline-danger";

  const heading2 = "Nikhil Rattu";
  const description2 =
    "We are the backbone of seamless project execution at BEAMS. With exceptional organizational skills and a proactive approach, they manage resources, timelines, and quality assurance to deliver outstanding results. Their dedication ensures that every project, whether residential or commercial, is completed on time, within budget, and to the highest standards of excellence.";
  // const image2 = "/assets/images/team2.jpg";
  const gradientColor2 = "#DBF1FD";
  const buttonVariant2 = "outline-success";

  return (
    <div>
      <h1 className="team-heading">Our Team</h1>
      <BoxProvider
        heading={heading}
        description={description}
        // image={image}
        gradientColor={gradientColor}
        buttonVariant={buttonVariant}
        heading2={heading2}
        description2={description2}
        // image2={image2}
        gradientColor2={gradientColor2}
        buttonVariant2={buttonVariant2}
        showButton={false} // Hide buttons on this page
      >
        <BoxWithContent />
      </BoxProvider>
    </div>
  );
}